//引入增强js
import '@/util/extends/toFirstUpperCase'

//所有的view页面功能显示点
//这叫菜单功能树
const viewTree = [
  {
    name: '主框架',
    flag: 'main',
    children: [
      {
        name: '首页',
        flag: 'home',
        children: [],
      },
      {
        name: '用户管理',
        flag: 'user',
        children: [
          {
            name: '配置管理部门按钮权限',
            flag: 'managementdepartmentBtn',
            children: [],
          },
          {
            name: '配置管理部门按钮权限',
            flag: 'managementmarketBtn',
            children: [],
          },
          {
            name: '配置角色按钮权限',
            flag: 'configurationRoleBtn',
            children: [],
          },
          {
            name: '配置品牌品类按钮权限',
            flag: 'brandCategoryBtn',
            children: [],
          },
          {
            name: '禁用按钮权限',
            flag: 'prohibitBtn',
            children: [],
          },
        ],
      },

      {
        name: '部门管理',
        flag: 'department',
        children: [],
      },

      {
        name: '职位管理',
        flag: 'position',
        children: [],
      },
      {
        name: '商场管理',
        flag: 'agent',
        children: [
          {
            name: '商场基本信息编辑修改权限',
            flag: 'edit',
            children: [
              {
                name: '法人姓名编辑权限',
                flag: 'corporateNameEditor',
              },
              {
                name: '法人手机号编辑权限',
                flag: 'corporateTelEditor',
              },
              {
                name: '法人身份证号编辑权限',
                flag: 'editorOfIDNO',
              },
              {
                name: '商场名称修改权限',
                flag: 'agentNameEditor',
              },
              {
                name: '区域名称修改权限',
                flag: 'agentSimpleNameEditor',
              },
            ],
          },
          {
            name: '商场店面信息修改权限',
            flag: 'storeEdit',
            children: [
              {
                name: '批量修改区域名称权限',
                flag: 'areaLabelsEditor',
              },
            ],
          },
          {
            name: '商场经营品类修改权限',
            flag: 'classEdit',
            children: [],
          },
          {
            name: '商场报表导出权限',
            flag: 'export',
            children: [],
          },
          {
            name: '商场列表导出权限',
            flag: 'exportList',
            children: [],
          },
          {
            name: '配置商场品牌品类编辑权限',
            flag: 'editbrandcategort',
            children: [],
          },
          {
            name: '控制商场基本信息是否可编辑',
            flag: 'baseInfoEdit',
          },
          {
            name: '配置商场品牌品类编辑权限',
            flag: 'editDepartment',
          },
          {
            name: '系统管理员信息',
            flag: 'sysAdmin',
            children: [
              {
                name: '重置密码权限',
                flag: 'resetPassword',
              },
            ],
          },
          {
            name: '经营品类及渠道信息',
            flag: 'businessCategory',
            children: [
              {
                name: 'k3编码权限',
                flag: 'k3editor',
              },
              {
                name: '结算系数编辑权限',
                flag: 'settlementCoefficientEditor',
              },
              {
                name: '审价线别编辑权限',
                flag: 'lineSeparationPriceVerificationEditor',
              },
              {
                name: '删除经营品类按钮',
                flag: 'brandcategorydeleteManager',
              },
              {
                name: '禁用经营品类按钮',
                flag: 'brandcategorySetDisabledManager',
              },
              {
                name: '传单开关按钮',
                flag: 'leafletOpen',
              },
            ],
          },
        ],
      },

      {
        name: '角色管理',
        flag: 'role',
        children: [],
      },

      {
        name: '权限管理',
        flag: 'access',
        children: [],
      },

      {
        name: '系统日志',
        flag: 'systemLog',
        children: [],
      },

      {
        name: '字典管理',
        flag: 'dict',
        children: [],
      },
    ],
  },
]
let list = []
let apiViewMerge = function (arr = [], prefix = 'view') {
  arr.forEach((v) => {
    let name = prefix + v.flag.toFirstUpperCase()
    // console.log(name, "name")
    list.push(name)
    apiViewMerge(v.children, name)
  })
}
apiViewMerge(viewTree)
export default viewTree
export const viewNameList = list
